import { render, staticRenderFns } from "./notificationsView.vue?vue&type=template&id=6525f144&scoped=true&"
import script from "./notificationsView.vue?vue&type=script&lang=js&"
export * from "./notificationsView.vue?vue&type=script&lang=js&"
import style0 from "./notificationsView.vue?vue&type=style&index=0&id=6525f144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525f144",
  null
  
)

export default component.exports